/** Stable load-key for review deep-link hydration vs heatmap occurrence opens. */

export function buildIncidentReviewDeepLinkLoadKey(args: {
  reviewMode: boolean;
  preserveExactOccurrence: boolean;
  incidentId: string;
  fromDate?: string | null;
  toDate?: string | null;
  heatmapHour?: string | number | null;
}): string {
  const heatmapHour =
    args.heatmapHour === null || args.heatmapHour === undefined || args.heatmapHour === ''
      ? ''
      : String(args.heatmapHour);
  return [
    args.reviewMode ? 'review' : 'detail',
    args.preserveExactOccurrence ? 'exact' : 'series',
    String(args.incidentId || '').trim(),
    String(args.fromDate || ''),
    String(args.toDate || ''),
    heatmapHour,
  ].join(':');
}
